import {camelizeKeys, decamelizeKeys} from 'humps'
import {
  fetcher,
  getHeaders,
  postHeaders,
  deleteHeaders,
} from '../../../../../app/javascript/api/fetcher'

const getPartnerBusinessMembershipPath = (partnerKey, supplierId) => {
  const partnerRoutes = {
    QBR: `qantas_business_membership`,
    VABF: `virgin_business_membership`,
  }

  const route = partnerRoutes[partnerKey]
  if (!route) {
    throw new Error(`Unknown partner key: ${partnerKey}`)
  }

  return `/points/api/suppliers/${supplierId}/${route}`
}

export const createVirginMembership = async ({
  supplierId,
  authenticityToken,
  params,
}) => {
  const body = decamelizeKeys(params, {deep: true})
  const opts = postHeaders({authenticityToken, body, raiseClientErrors: false})

  return fetcher(
    `${getPartnerBusinessMembershipPath('VABF', supplierId)}`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const createQantasMembership = async ({
  supplierId,
  authenticityToken,
  params,
}) => {
  const body = decamelizeKeys(params, {deep: true})
  const opts = postHeaders({authenticityToken, body, raiseClientErrors: false})

  return fetcher(
    `${getPartnerBusinessMembershipPath('QBR', supplierId)}`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const fetchVirginMembershipPrepopulationData = async ({supplierId}) => {
  const opts = getHeaders()

  return fetcher(
    `${getPartnerBusinessMembershipPath('VABF', supplierId)}/prefill`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const fetchQantasMembershipPrepopulationData = async ({supplierId}) => {
  const opts = getHeaders()

  return fetcher(
    `${getPartnerBusinessMembershipPath('QBR', supplierId)}/prefill`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const redeemPoints = async ({
  supplierId,
  redemptionPartnerId,
  redemptionPartnerMembershipId,
  authenticityToken,
  params,
}) => {
  const body = decamelizeKeys(params, {deep: true})
  const opts = postHeaders({authenticityToken, body, raiseClientErrors: false})

  return fetcher(
    `/points/api/suppliers/${supplierId}/redemption_partners/${redemptionPartnerId}/redemption_partner_memberships/${redemptionPartnerMembershipId}/point_redemptions`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const disconnectMembership = async ({
  supplierId,
  authenticityToken,
  partnerKey,
}) => {
  const opts = deleteHeaders({
    authenticityToken,
    raiseClientErrors: false,
  })

  const endpoint = getPartnerBusinessMembershipPath(partnerKey, supplierId)

  return fetcher(endpoint, opts).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}

export const acceptTermsAndConditions = async ({
  supplierId,
  authenticityToken,
}) => {
  const opts = postHeaders({authenticityToken, raiseClientErrors: false})

  return fetcher(
    `/points/api/suppliers/${supplierId}/terms_acceptance`,
    opts,
  ).then((data) => {
    return camelizeKeys(data, {deep: true})
  })
}
